interface PageHeroProps {
  eyebrow: string;
  title: string;
  description?: string;
  image?: string;
}

export default function PageHero({ eyebrow, title, description, image }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img
            src={image}
            alt={`${title} 배경 이미지`}
            title={`${title} - 비앙카 피부관리`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/40 to-background-50"></div>
        </div>
      )}

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 md:pt-36 pb-14 md:pb-20 max-w-6xl mx-auto flex flex-col items-center text-center">
        <span className="animate-fade-in-up inline-flex items-center gap-3 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
          <span className="w-6 h-px bg-primary-400"></span>
          {eyebrow}
          <span className="w-6 h-px bg-primary-400"></span>
        </span>
        <h1
          className="animate-fade-in-up mt-5 text-3xl md:text-5xl font-bold text-foreground-900 leading-tight"
          style={{ animationDelay: "120ms" }}
        >
          {title}
        </h1>
        {description && (
          <p
            className="animate-fade-in-up mt-5 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed"
            style={{ animationDelay: "240ms" }}
          >
            {description}
          </p>
        )}
      </div>
    </section>
  );
}